/// <amd-module name="Checks/Client/RestClient/PipelinesChecks" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   pipelinepolicy\client\checks\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as PipelinesChecks from "Checks/Client/Contracts/PipelinesChecks";

export interface IPipelinesChecksRestClient extends IVssRestClient {
    /**
     * Add a check configuration
     * 
     * @param configuration - 
     * @param project - Project ID or project name
     */
    addCheckConfiguration(configuration: PipelinesChecks.CheckConfiguration, project: string): Promise<PipelinesChecks.CheckConfiguration>;
    /**
     * Delete check configuration by id
     * 
     * @param project - Project ID or project name
     * @param id - check configuration id
     */
    deleteCheckConfiguration(project: string, id: number): Promise<void>;
    /**
     * Get Check configuration by Id
     * 
     * @param project - Project ID or project name
     * @param id - 
     * @param expand - 
     */
    getCheckConfiguration(project: string, id: number, expand?: PipelinesChecks.CheckConfigurationExpandParameter): Promise<PipelinesChecks.CheckConfiguration>;
    /**
     * Get Check configuration by resource type and id
     * 
     * @param project - Project ID or project name
     * @param resourceType - resource type
     * @param resourceId - resource id
     * @param expand - 
     */
    getCheckConfigurationsOnResource(project: string, resourceType?: string, resourceId?: string, expand?: PipelinesChecks.CheckConfigurationExpandParameter): Promise<PipelinesChecks.CheckConfiguration[]>;
    /**
     * Update check configuration
     * 
     * @param configuration - check configuration
     * @param project - Project ID or project name
     * @param id - check configuration id
     */
    updateCheckConfiguration(configuration: PipelinesChecks.CheckConfiguration, project: string, id: number): Promise<PipelinesChecks.CheckConfiguration>;
    /**
     * Get check configurations for multiple resources by resource type and id.
     * 
     * @param resources - List of resources.
     * @param project - Project ID or project name
     * @param expand - The properties that should be expanded in the list of check configurations.
     */
    queryCheckConfigurationsOnResources(resources: PipelinesChecks.Resource[], project: string, expand?: PipelinesChecks.CheckConfigurationExpandParameter): Promise<PipelinesChecks.CheckConfiguration[]>;
    /**
     * Initiate an evaluation for a check in a pipeline
     * 
     * @param request - 
     * @param project - Project ID or project name
     * @param expand - 
     */
    evaluateCheckSuite(request: PipelinesChecks.CheckSuiteRequest, project: string, expand?: PipelinesChecks.CheckSuiteExpandParameter): Promise<PipelinesChecks.CheckSuite>;
    /**
     * Get details for a specific check evaluation
     * 
     * @param project - Project ID or project name
     * @param checkSuiteId - 
     * @param expand - 
     */
    getCheckSuite(project: string, checkSuiteId: string, expand?: PipelinesChecks.CheckSuiteExpandParameter): Promise<PipelinesChecks.CheckSuite>;
    /**
     * Update a check run of a check suite
     * 
     * @param request - 
     * @param project - Project ID or project name
     * @param checkSuiteId - 
     * @param expand - 
     */
    updateCheckSuite(request: PipelinesChecks.CheckSuiteUpdateParameter, project: string, checkSuiteId: string, expand?: PipelinesChecks.CheckSuiteExpandParameter): Promise<PipelinesChecks.CheckSuite>;
}

class PipelinesChecksRestClient extends RestClientBase implements IPipelinesChecksRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Add a check configuration
     * 
     * @param configuration - 
     * @param project - Project ID or project name
     */
    public async addCheckConfiguration(
        configuration: PipelinesChecks.CheckConfiguration,
        project: string
        ): Promise<PipelinesChecks.CheckConfiguration> {

        return this.beginRequest<PipelinesChecks.CheckConfiguration>({
            apiVersion: "5.2-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/checks/configurations/{id}",
            routeValues: {
                project: project
            },
            body: configuration
        });
    }

    /**
     * Delete check configuration by id
     * 
     * @param project - Project ID or project name
     * @param id - check configuration id
     */
    public async deleteCheckConfiguration(
        project: string,
        id: number
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.2-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/pipelines/checks/configurations/{id}",
            routeValues: {
                project: project,
                id: id
            }
        });
    }

    /**
     * Get Check configuration by Id
     * 
     * @param project - Project ID or project name
     * @param id - 
     * @param expand - 
     */
    public async getCheckConfiguration(
        project: string,
        id: number,
        expand?: PipelinesChecks.CheckConfigurationExpandParameter
        ): Promise<PipelinesChecks.CheckConfiguration> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckConfiguration>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "{project}/_apis/pipelines/checks/configurations/{id}",
            routeValues: {
                project: project,
                id: id
            },
            queryParams: queryValues
        });
    }

    /**
     * Get Check configuration by resource type and id
     * 
     * @param project - Project ID or project name
     * @param resourceType - resource type
     * @param resourceId - resource id
     * @param expand - 
     */
    public async getCheckConfigurationsOnResource(
        project: string,
        resourceType?: string,
        resourceId?: string,
        expand?: PipelinesChecks.CheckConfigurationExpandParameter
        ): Promise<PipelinesChecks.CheckConfiguration[]> {

        const queryValues: any = {
            resourceType: resourceType,
            resourceId: resourceId,
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckConfiguration[]>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "{project}/_apis/pipelines/checks/configurations/{id}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Update check configuration
     * 
     * @param configuration - check configuration
     * @param project - Project ID or project name
     * @param id - check configuration id
     */
    public async updateCheckConfiguration(
        configuration: PipelinesChecks.CheckConfiguration,
        project: string,
        id: number
        ): Promise<PipelinesChecks.CheckConfiguration> {

        return this.beginRequest<PipelinesChecks.CheckConfiguration>({
            apiVersion: "5.2-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/checks/configurations/{id}",
            routeValues: {
                project: project,
                id: id
            },
            body: configuration
        });
    }

    /**
     * Get check configurations for multiple resources by resource type and id.
     * 
     * @param resources - List of resources.
     * @param project - Project ID or project name
     * @param expand - The properties that should be expanded in the list of check configurations.
     */
    public async queryCheckConfigurationsOnResources(
        resources: PipelinesChecks.Resource[],
        project: string,
        expand?: PipelinesChecks.CheckConfigurationExpandParameter
        ): Promise<PipelinesChecks.CheckConfiguration[]> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckConfiguration[]>({
            apiVersion: "5.2-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/checks/queryconfigurations",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: resources
        });
    }

    /**
     * Initiate an evaluation for a check in a pipeline
     * 
     * @param request - 
     * @param project - Project ID or project name
     * @param expand - 
     */
    public async evaluateCheckSuite(
        request: PipelinesChecks.CheckSuiteRequest,
        project: string,
        expand?: PipelinesChecks.CheckSuiteExpandParameter
        ): Promise<PipelinesChecks.CheckSuite> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckSuite>({
            apiVersion: "5.2-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/pipelines/checks/runs/{checkSuiteId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: request
        });
    }

    /**
     * Get details for a specific check evaluation
     * 
     * @param project - Project ID or project name
     * @param checkSuiteId - 
     * @param expand - 
     */
    public async getCheckSuite(
        project: string,
        checkSuiteId: string,
        expand?: PipelinesChecks.CheckSuiteExpandParameter
        ): Promise<PipelinesChecks.CheckSuite> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckSuite>({
            apiVersion: "5.2-preview.1",
            routeTemplate: "{project}/_apis/pipelines/checks/runs/{checkSuiteId}",
            routeValues: {
                project: project,
                checkSuiteId: checkSuiteId
            },
            queryParams: queryValues
        });
    }

    /**
     * Update a check run of a check suite
     * 
     * @param request - 
     * @param project - Project ID or project name
     * @param checkSuiteId - 
     * @param expand - 
     */
    public async updateCheckSuite(
        request: PipelinesChecks.CheckSuiteUpdateParameter,
        project: string,
        checkSuiteId: string,
        expand?: PipelinesChecks.CheckSuiteExpandParameter
        ): Promise<PipelinesChecks.CheckSuite> {

        const queryValues: any = {
            '$expand': expand
        };

        return this.beginRequest<PipelinesChecks.CheckSuite>({
            apiVersion: "5.2-preview.1",
            method: "PATCH",
            routeTemplate: "{project}/_apis/pipelines/checks/runs/{checkSuiteId}",
            routeValues: {
                project: project,
                checkSuiteId: checkSuiteId
            },
            queryParams: queryValues,
            body: request
        });
    }

}

export const PipelinesChecksClientName = "IPipelinesChecksRestClient";

export function getPipelinesChecksClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPipelinesChecksRestClient {
    return pageContext.getRestClient<IPipelinesChecksRestClient>(PipelinesChecksClientName, options);
}

RestClients.add(PipelinesChecksClientName, { 
    factory: PipelinesChecksRestClient,
    options: {
        resourceAreaId: "4a933897-0488-45af-bd82-6fd3ad33f46a",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
